import React from 'react';
import cn from 'classnames';
import styles from './Typography.module.scss';
import { TypographyVariant } from './Typography.types';

interface Props {
  variant: TypographyVariant;
  as?: React.ElementType;
  className?: string;
  children: React.ReactNode;
}

export const Typography: React.FC<Props> = ({
  variant,
  as: Component = 'p',
  className,
  children,
  ...rest
}) => {
  return (
    <Component className={cn(styles[variant], className)} {...rest}>
      {children}
    </Component>
  );
};
